
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';

  @Component
  export default class DlgAdvisorNew extends Vue {
    public $refs!: {
      form: any,
    };

    @Action('admin/advisors/create') private createAdvisor!: any;
    @Action('admin/advisors/read') private readAdvisors!: any;
    @Getter('common/rules/all') private rules!: any;

    private advisor: any = {};
    private dialog: boolean = false;
    private loading: boolean = false;
    private valid: boolean = true;

    private async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        // Step 1: save advisor
        const success = await this.createAdvisor(this.advisor);
        if (success) {
          await this.readAdvisors();
          this.loading = false;
          this.dialog = false;
          this.advisor = {};
          this.$refs.form.resetValidation();
        } else {
          this.loading = false;
        }
      }
    }
  }
